import { getSubdomain } from './utils';

// University colles that don't have families feature
export const UNIVERSITY_COLLES = [
  'arreplegats',
  'bergants',
  'descargolats',
  'emboirats',
  'engrescats',
  'gambirots',
  'ganapies',
  'grillats',
  'llunatics',
  'marracos',
  'penjats',
  'trempats',
  'xoriguers',
  'passerells'
];

/**
 * Check if current colla is a university colla
 * @returns {boolean} true if current colla is a university colla
 */
export const isUniversityColla = () => {
  const colla = getSubdomain();
  return UNIVERSITY_COLLES.includes(colla);
};

/**
 * Check if families feature is available for current colla
 * @returns {boolean} true if families feature should be shown
 */
export const hasFamiliesFeature = () => {
  return !isUniversityColla();
};

/**
 * Check if Aleta billing feature is available for current colla
 * @returns {boolean} true if Aleta billing should be shown
 */
export const hasAletaBillingFeature = () => {
  return !isUniversityColla();
};

// Colles that use altura_mans field
const ALTURA_MANS_COLLES = ['esquerdats', 'engrescats', 'escatllots', 'falconspiera', 'falconsbcn', 'baixmontseny', 'santfeliu', 'mallorca', 'gambirots'];

const NUCLIS_SUMMARY_COLLES = ['engrescats', 'sarri', 'llunatics'];

/**
 * Check if altura_mans column should be shown for current colla
 * @param {string} [colla] optional colla id, useful for tests
 * @returns {boolean} true if altura_mans should be shown
 */
export const hasAlturaMansFeature = (colla = getSubdomain()) => {
  return ALTURA_MANS_COLLES.includes(colla);
};

/**
 * Check if nuclis summary should be shown for current colla
 * @param {string} [colla] optional colla id, useful for tests
 * @returns {boolean} true if resum de nuclis should be shown
 */
export const hasNuclisSummaryFeature = (colla = getSubdomain()) => {
  return NUCLIS_SUMMARY_COLLES.includes(colla);
};
